import { lazy } from 'react';

export default [
    {
        path: '/taipeiff-workshop',
        exact: true,
        component: lazy(() => import(/* webpackChunkName: 'TaipeiffWorkshopLayout' */ './layout')),
    },
];
